import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const ITEMS = [
  {
    slug: "bathroom-tissue-36-rolls",
    category: "Bathroom Tissue",
    title: "Soft. Strong. Made for everyday comfort.",
    image: "/products/img_07.png",
  },
  {
    slug: "kitchen-towel-15-rolls",
    category: "Kitchen Towels",
    title: "Soaks up every mess and spill.",
    image: "/products/img_13.png",
  },
  {
    slug: "facial-tissue-100ct",
    category: "Facial Tissue",
    title: "Gentle softness for every touch.",
    image: "/products/img_03.png",
  },
  {
    slug: "baby-wipes-72ct",
    category: "Wipes",
    title: "Gentle care for life's smallest moments.",
    image: "/products/img_09.png",
  },
];

export default function Essentials() {
  return (
    <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 md:py-28" data-testid="essentials-section" id="essentials">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
        <div>
          <p className="text-[11px] uppercase tracking-[0.3em] text-amber-500 font-bold">Shop everyday essentials</p>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-black text-[#0f2a5c] tracking-tight leading-[1.04] max-w-3xl">
            Everyday Essentials. Made Better.
          </h2>
        </div>
        <Link
          to="/shop"
          data-testid="essentials-shop-all-link"
          className="hidden md:inline-flex items-center gap-2 font-display font-bold text-sm uppercase tracking-widest text-[#173a7a] hover:text-amber-500"
        >
          Shop all products <ArrowRight size={16} />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {ITEMS.map((it, i) => (
          <motion.div
            key={it.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            data-testid={`essentials-card-${it.slug}`}
          >
            <Link to={`/shop/${it.slug}`} className="group block">
              <div className="relative rounded-3xl p-[2px] bg-gradient-to-br from-sky-300 via-[#173a7a] to-sky-400 shadow-[0_20px_50px_-20px_rgba(23,58,122,0.35)] group-hover:shadow-[0_30px_70px_-20px_rgba(23,58,122,0.55)] transition-shadow duration-500">
                <div className="relative aspect-[4/5] rounded-[calc(1.5rem-2px)] bg-white overflow-hidden">
                  <div aria-hidden className="pointer-events-none absolute -inset-x-full inset-y-0 bg-gradient-to-r from-transparent via-white/50 to-transparent skew-x-12 opacity-0 group-hover:opacity-100 group-hover:translate-x-full transition-all duration-1000" />
                  <img
                    src={it.image}
                    alt={it.category}
                    className="absolute inset-0 w-full h-full object-contain p-6 transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              </div>
              <div className="mt-5">
                <p className="text-xs uppercase tracking-[0.25em] text-amber-500 font-bold">{it.category}</p>
                <p className="mt-2 font-display text-lg md:text-xl font-bold text-[#0f2a5c] group-hover:text-[#1a4694] transition-colors leading-snug">
                  {it.title}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-[#173a7a] group-hover:gap-3 transition-all">
                  Shop {it.category} <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>

      <div className="mt-12 text-center md:hidden">
        <Link
          to="/shop"
          className="inline-flex items-center gap-2 rounded-full bg-[#173a7a] text-white font-display font-bold px-7 py-3.5 text-sm uppercase tracking-widest"
        >
          Shop all products <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  );
}
